// extracted by mini-css-extract-plugin
export default {"cartItemContainer":"cartItem_cartItemContainer__wL4J3","itemDetails":"cartItem_itemDetails__1r8rG","name":"cartItem_name__fR79L"};